module.exports = __webpack_public_path__ + "static/img/guide-02.cf0c1cd3.png";